import React from 'react';
import { Tooltip, Typography, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const FixedWidthText = ({ text = '', maxLength = 10, truncated = true, noTruncateText = "" }) => {
    const handleCopy = () => {
        if (text) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    console.log('Text copied to clipboard:', text);
                })
                .catch(err => {
                    console.error('Failed to copy text:', err);
                });
        }
    };

    let displayText;

    if (truncated && maxLength === -1) {
        // Take only the first word, handle null/undefined text
        displayText = text ? text.split(' ')[0] + '...' : '';
    } else if (truncated && text && text.length > maxLength) {
        // Truncate text if longer than maxLength, handle null/undefined text
        displayText = text ? text.substring(0, maxLength) + '...' : '';
    } else {
        displayText = text || '';
    }

    return (
        <Tooltip title={text || ''} arrow disableHoverListener={!truncated}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '200px', overflow: 'hidden' }}>
                <Typography variant="body2" noWrap={truncated} style={{ flex: 1 }}>
                    {noTruncateText} {displayText}
                </Typography>
                {text && <IconButton size="small" onClick={handleCopy}>
                    <ContentCopyIcon fontSize="small" />
                </IconButton>
                }
            </div>
        </Tooltip>
    );
};

export default FixedWidthText;
